/**
 * FAQ answer panel — instant show/hide (no expand animation).
 */
export default function FaqAccordionPanel({ isOpen, children, contentClassName = "" }) {
  if (!isOpen) return null;
  return <div className={contentClassName}>{children}</div>;
}
